import React, { useEffect, useState } from 'react';
import { Card, Form } from 'antd';

import EquipmentForm from '../EquipmentForm/EquipmentForm';
import Headline from '../../../UI/Headline/Headline';
import api from '../../../../api';
import EquipmentService from '../../../../Services/api/EquipmentService';

function EditEquipment({ equipmentId, companyId }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getEquipment = async () => {
            const equipmentData = await EquipmentService.findOne(equipmentId);
            form.setFieldsValue(equipmentData);
            setLoading(false);
        };

        getEquipment();
    }, []);

    const editEquipmentHandler = async (equipment) => {
        setLoading(true);
        const payload = { ...equipment, companyId: Number(companyId) };
        try {
            await api.editEquipment(equipmentId, payload);
            window.location.href = '/admin/equipments';
        } catch (err) {
            alert('Coś poszło nie tak');
        }
        setLoading(false);
    };


    return (
        <Card bordered>
            <Headline title="Edytuj sprzęt" />
            <EquipmentForm
                form={form}
                loading={loading}
                successHandler={editEquipmentHandler}
                submitButtonText="Zapisz"
            />
        </Card>
    );
}

export default EditEquipment;
